import { render, staticRenderFns } from "./PositionMarginModal.vue?vue&type=template&id=b3b1c7e0&scoped=true"
import script from "./PositionMarginModal.vue?vue&type=script&lang=js"
export * from "./PositionMarginModal.vue?vue&type=script&lang=js"
import style0 from "./PositionMarginModal.vue?vue&type=style&index=0&id=b3b1c7e0&prod&lang=scss&scoped=true"
import style1 from "./PositionMarginModal.vue?vue&type=style&index=1&id=b3b1c7e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b1c7e0",
  null
  
)

export default component.exports